const V2_ONBOARDING_ROLE_SELECTION_PATH = '/onboarding/role/selection'

const PENDING_INVITES_TOAST = {
  title: 'Pending invites',
  description: 'You have pending invites in Rise. Taking you there.',
  variant: 'success',
  time: 3000,
}

const V2_ONBOARDING_TOAST = {
  title: 'Taking you to Rise',
  description: "We're moving you to the new Rise experience.",
  variant: 'success',
  time: 3000,
}

const V2_REDIRECT_TOAST_BY_REASON = {
  pending_invites: PENDING_INVITES_TOAST,
  v2_onboarding: V2_ONBOARDING_TOAST,
}

const PENDING_INVITES_REDIRECT_DELAY_MS = 2000

export function useRedirectToV2Onboarding(options = {}) {
  const runtimeConfig = useRuntimeConfig()
  const baseUrl = (runtimeConfig.public.V2_PUBLIC_URL || '').replace(/\/$/, '')
  const url = `${baseUrl}${V2_ONBOARDING_ROLE_SELECTION_PATH}`

  function redirectToV2Onboarding() {
    if (import.meta.server) {
      return navigateTo(url, { external: true, replace: true })
    }
    window.location.replace(url)
    return Promise.resolve()
  }

  function redirectToV2OnboardingWithPendingInvitesToast(toast) {
    if (toast) {
      const toastConfig =
        V2_REDIRECT_TOAST_BY_REASON[options.reason] || V2_ONBOARDING_TOAST
      toast.show(toastConfig)
    }
    setTimeout(() => redirectToV2Onboarding(), PENDING_INVITES_REDIRECT_DELAY_MS)
  }

  return {
    redirectToV2Onboarding,
    redirectToV2OnboardingWithPendingInvitesToast,
    v2OnboardingUrl: url,
    PENDING_INVITES_TOAST,
    V2_ONBOARDING_TOAST,
    V2_REDIRECT_TOAST_BY_REASON,
    V2_ONBOARDING_ROLE_SELECTION_PATH,
  }
}
